import Component from './InDmMessage.vue'
export default Component
export * from './types'
